<div class="form-errors" *ngIf="serveurErrors && serveurErrors.length">
	<ul class="error">
		<li *ngFor="let error of serveurErrors">
					<span class="btn-icon-circle btn-circle-xxxs">
					<i class="icon-exclamation"></i>
					</span>
			<span>{{error}}</span>
		</li>
	</ul>
</div>